import { render, staticRenderFns } from "./create-asset-wizard.vue?vue&type=template&id=6a4fad3a&scoped=true&"
import script from "./create-asset-wizard.vue?vue&type=script&lang=ts&"
export * from "./create-asset-wizard.vue?vue&type=script&lang=ts&"
import style0 from "./create-asset-wizard.vue?vue&type=style&index=0&id=6a4fad3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4fad3a",
  null
  
)

export default component.exports